var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3047 12.5938C13.0703 12.8281 12.6406 12.8281 12.4062 12.5938L7.25 7.39844L2.05469 12.5938C1.82031 12.8281 1.39062 12.8281 1.15625 12.5938C0.921875 12.3594 0.921875 11.9297 1.15625 11.6953L6.35156 6.5L1.15625 1.34375C0.921875 1.10938 0.921875 0.679688 1.15625 0.445312C1.39062 0.210938 1.82031 0.210938 2.05469 0.445312L7.25 5.64062L12.4062 0.445312C12.6406 0.210938 13.0703 0.210938 13.3047 0.445312C13.5391 0.679688 13.5391 1.10938 13.3047 1.34375L8.10938 6.5L13.3047 11.6953C13.5391 11.9297 13.5391 12.3594 13.3047 12.5938Z",
    fill: "#646464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.d47c3f5e.svg";
export { ForwardRef as ReactComponent };